import { createBrowserRouter } from "react-router-dom";
import ErrorBoundary from "./components/common/ErrorBoundary";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import Dashboard from "./pages/dashboard/Dashboard";
import GlobalContextProvider from "./contexts/GlobalContext";
import BaseLayout from "./layouts/BaseLayout";
import OrderPage from "./pages/processes/order/OrderPage";
import ShipmentsPage from "./pages/processes/shipments/ShipmentsPage";
import ContactsPage from "./pages/setup/contacts/ContactsPage";
import ProductsPage from "./pages/setup/products/ProductsPage";
import InventoryPage from "./pages/processes/inventory/InventoryPage";
import AddProductPage from "./pages/setup/products/AddProductPage";
import UpdateProductPage from "./pages/setup/products/updateProductPage";
import AddContactPage from "./pages/setup/contacts/AddContactPage";
import UpdateContactPage from "./pages/setup/contacts/UpdateContactPage";
import AddOrderPage from "./pages/processes/order/AddOrderPage";
import UpdateOrderPage from "./pages/processes/order/UpdateOrderPage";
import DevicesPage from "./pages/setup/devices/DevicesPage";
import AddDevicePage from "./pages/setup/devices/AddDevicePage";
import UpdateDevicePage from "./pages/setup/devices/UpdateDevicePage";
import TagsPage from "./pages/setup/tags/TagsPage";
import AddTagPage from "./pages/setup/tags/AddTagPage";
import UpdateTagPage from "./pages/setup/tags/UpdateTagPage";
import Activities from "./pages/activities/Activities";
import AddShipmentInbound from "./pages/processes/order/AddShipmentInbound";
import ContactCreateSystemUser from "./pages/setup/contacts/ContactCreateSystemUser";
import ContactUpdateSystemUser from "./pages/setup/contacts/ContactUpdateSystemUser";
import SearchTagPage from "./pages/SearchTagPage";
import UpdateSettingsPage from "./pages/settings/UpdateSettingsPage";
import ProtectedRoute from "./components/ProtectedRoute";

export const router = createBrowserRouter([
  {
    path: "auth",
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <Login />,
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "register",
        element: <Register />,
      },
    ],
  },
  {
    path: "/",
    element: (
      <GlobalContextProvider>
        <BaseLayout />
      </GlobalContextProvider>
    ),
    errorElement: <ErrorBoundary />,

    children: [
      { index: true, element: <Dashboard /> },
      { path: "/dashboard", element: <Dashboard /> },
      // { path: "/profile", element: <Profile /> },
      { path: "/activities", element: <Activities /> },
      {
        path: "/settings",
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute permissions={["admin"]}>
                <UpdateSettingsPage />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "/processes",
        children: [
          {
            path: "order",
            children: [
              { index: true, element: <OrderPage /> },
              { path: "add", element: <AddOrderPage /> },
              { path: "update/:id", element: <UpdateOrderPage /> },
            ],
          },
          {
            path: "shipments",
            children: [
              { index: true, element: <ShipmentsPage /> },
              { path: "inbound/add/:orderId", element: <AddShipmentInbound /> },
              { path: "update/:id", element: <UpdateProductPage /> },
            ],
          },
          { path: "inventory", element: <InventoryPage /> },
        ],
      },
      {
        path: "search",
        children: [{ index: true, element: <SearchTagPage /> }],
      },
      {
        path: "/setup",
        children: [
          {
            path: "products",
            children: [
              { index: true, element: <ProductsPage /> },
              { path: "add", element: <AddProductPage /> },
              { path: "update/:id", element: <UpdateProductPage /> },
            ],
          },
          {
            path: "contacts",
            children: [
              { index: true, element: <ContactsPage /> },
              { path: "add", element: <AddContactPage /> },
              {
                path: "update/:id/system-user/add",
                element: <ContactCreateSystemUser />,
              },
              {
                path: "update/:id/system-user/update",
                element: <ContactUpdateSystemUser />,
              },
              { path: "update/:id", element: <UpdateContactPage /> },
            ],
          },
          {
            path: "devices",
            children: [
              { index: true, element: <DevicesPage /> },
              { path: "add", element: <AddDevicePage /> },
              { path: "update/:id", element: <UpdateDevicePage /> },
            ],
          },
          {
            path: "tags",
            children: [
              { index: true, element: <TagsPage /> },
              { path: "add", element: <AddTagPage /> },
              { path: "update/:id", element: <UpdateTagPage /> },
            ],
          },
        ],
      },
    ],
  },
]);
